module.exports = __webpack_public_path__ + "3a35194e992a9d7eaf15d24e1f5067ba.svg";